var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignout28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5.722c0-2.472 2.22-4.355 4.65-3.905 1.327.245 2.611.498 3.35.683 1.099.275 3.406 1.002 5.261 1.602A3.965 3.965 0 0 1 25 7.883v12.234c0 1.722-1.1 3.251-2.739 3.78-1.855.6-4.162 1.328-5.261 1.603-.739.185-2.023.438-3.35.683-2.43.45-4.65-1.433-4.65-3.905V5.722ZM3 8a3 3 0 0 1 3-3v18a3 3 0 0 1-3-3V8Zm11 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout28);
export default __webpack_public_path__ + "static/media/signout_28.a322ed44.svg";
export { ForwardRef as ReactComponent };